import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Dialog, {
  DialogContent,
  DialogTitle,
} from 'components/common/Dialog';
import Progress from 'components/common/Progress';

import formatOrderNumber from 'utils/formatOrderNumber';

import { fetchOrdersLinesClaims } from 'redux/modules/ordersLinesClaims';

import ClaimLogViewTable from './ClaimLogViewTable';

const styles = () => ({
  dialogPaper: {
    maxWidth: 1100,
    minWidth: 1100,
  },
});

const ClaimLogViewDialog = ({
  Claim,
  Insurance,
  open,
  onClose,
  business,
  actions,
  Patient,
  classes,
  ...otherProps
}) => (
  <Dialog
    paperClassName={classes.dialogPaper}
    open={open}
    onClose={onClose}
    onEnter={() => {
      if (!Claim || !Claim[0]
        || Claim.filter(item => item['Create At']).length !== Claim.length) {
        actions.fetchOrdersLinesClaims({
          filters: [{
            name: 'Order Line ID',
            operation: 'in',
            // val: otherProps.ID,
            val: otherProps['Order Line ID'],
          }],
          sort_by: [{
            name: 'Create At',
            sort: 'desc',
          }],
          triggerLoading: false,
        });
      }
    }}
    maxWidth={false}
  >
    <DialogTitle onCloseClick={onClose}>
      <Typography
        variant="title"
        color="secondary"
        align="center"
      >
        {otherProps['HCPC S Code']
          ? `Claim Log for ${otherProps['HCPC S Code']} from Order ${formatOrderNumber(otherProps['Order ID'])}`
          : `Claim Log for Order ${formatOrderNumber(otherProps['Order ID'])}`}
        {', '}
        {Patient && Patient['Record Number'] ? `${Patient['First Name']} ${Patient['Last Name']}` : 'Patient Deleted'}
      </Typography>
    </DialogTitle>
    <DialogContent
      withScrollbars
      disableGutters
      fullHeight
      scrollbarsRef={(scrollbarsRef) => {
        this.scrollbarsRef = scrollbarsRef;
      }}
    >
      {Claim && Claim[0] && Claim.filter(item => item['Create At']).length === Claim.length ? (
        <ClaimLogViewTable
          Claim={Claim}
          Insurance={Insurance}
          business={business}
          variant={otherProps['HCPC S Code'] ? 'order-line' : 'order'}
        />
      ) : (
        <Progress />
      )}
    </DialogContent>
  </Dialog>
);

ClaimLogViewDialog.propTypes = {
  Claim: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
    'Claim Status': PropTypes.string,
    'Create At': PropTypes.string,
  })),
  Insurance: PropTypes.shape({
    'Payer Name': PropTypes.string.isRequired,
    'Order Benefits': PropTypes.string.isRequired,
  }).isRequired,
  // ID: PropTypes.arrayOf(PropTypes.number).isRequired,
  'Order Line ID': PropTypes.arrayOf(PropTypes.number.isRequired),
  'Order ID': PropTypes.number.isRequired,
  'HCPC S Code': PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  business: PropTypes.shape({
    ID: PropTypes.number,
  }),
  Patient: PropTypes.shape({
    'Record Number': PropTypes.number,
  }).isRequired,
  actions: PropTypes.shape({
    fetchOrdersLinesClaims: PropTypes.func.isRequired,
  }).isRequired,
};

ClaimLogViewDialog.defaultProps = {
  open: false,
  onClose: () => {},
  Insurance: [],
  business: {},
  Claim: null,
  'HCPC S Code': null,
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ fetchOrdersLinesClaims }, dispatch),
});

export default connect(null, mapDispatchToProps)(
  withStyles(styles)(ClaimLogViewDialog),
);



// WEBPACK FOOTER //
// ./src/components/workflow/ClaimLogViewDialog/ClaimLogViewDialog.js